
import React from 'react'
import {Component} from 'react'

import QueryWidget from './QueryWidget'
import QuerySpacer from './QuerySpacer'


function QueryMatrix(
    {columns, widgetTypes, autocomplete,
     onValueChange, onFieldChange, onPlusClick, onSearchClick, onDelete,
     enabled
    }
    ) {

    let row_elements = [];
    for (let x=0; x<columns.length; ++x) {
        let column_elements = [];
        for (let y=0; y<columns[x].length; ++y) {
            const widget_data = columns[x][y];
            const can_delete = columns.length > 1 || columns[x].length > 1;
            column_elements.push(
                <QueryWidget {...widget_data} key={y*2} xy={[x,y]}
                             widgetTypes={widgetTypes}
                             widgetData={widget_data}
                             autocomplete={autocomplete}
                             onValueChange={onValueChange}
                             onFieldChange={onFieldChange}
                             onSubmit={onSearchClick}
                             onDelete={onDelete}
                             canDelete={can_delete}
                />
            );
            if (y < columns[x].length-1) {
                column_elements.push(
                    <QuerySpacer type={"or"} key={y * 2 + 1}/>
                );
            }
        }
        column_elements.push(
            <QuerySpacer type={"plus"} key={-1} onClick={onPlusClick} xy={[x, columns[x].length]}/>
        );
        row_elements.push(<div className={"query-column"} key={x*2}>{column_elements}</div>);
        if (x < columns.length-1)
            row_elements.push((
                <div className={"query-column"} key={x*2+1}>
                    <QuerySpacer type={"and"}/>
                </div>
            ));
    }
    row_elements.push((
        <div className={"query-column"} key={-1}>
            <QuerySpacer type={"plus"} onClick={onPlusClick} xy={[columns.length, 0]}/>
        </div>
    ));

    return (
        <div>
            <div className={"query-row"}>
                {row_elements}
            </div>
            <button className="button" disabled={!enabled} onClick={onSearchClick}>Aktualisieren</button>
        </div>
    );
}

export default QueryMatrix;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/QueryMatrix.js